// store/bankDataSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../api/axiosInstance';

const BANKS_URL = `${process.env.REACT_APP_API_BASE_URL}/api/settings/banks/`;
const BRANCHES_URL = `${process.env.REACT_APP_API_BASE_URL}/api/settings/branches/`;

// Single combined bank list across all countries (no country filter/selector in the UI).
export const fetchBanks = createAsyncThunk(
  'bankData/fetchBanks',
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(BANKS_URL);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Fetch failed');
    }
  }
);

export const fetchBranches = createAsyncThunk(
  'bankData/fetchBranches',
  async (bankId, thunkAPI) => {
    try {
      const response = await axios.get(BRANCHES_URL, { params: { bank: bankId } });
      return { bankId, branches: response.data };
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Fetch failed');
    }
  }
);

const bankDataSlice = createSlice({
  name: 'bankData',
  initialState: {
    banks: [],
    banksLoaded: false,
    branchesByBank: {},
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBanks.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBanks.fulfilled, (state, action) => {
        state.loading = false;
        state.banksLoaded = true;
        state.banks = action.payload;
      })
      .addCase(fetchBanks.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchBranches.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBranches.fulfilled, (state, action) => {
        state.loading = false;
        state.branchesByBank[action.payload.bankId] = action.payload.branches;
      })
      .addCase(fetchBranches.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default bankDataSlice.reducer;
